import React from "react";
import {Select, Input, ColumnLayout} from "@amzn/awsui-components-react";
import {AGGREGATE_TYPES, FILTER_TYPES} from "../CalcDetails";

export class FilterCard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {...this.props.data};
  }

  handleChange = (change, e) => {
    const newState = {};
    newState[change] = e.detail.selectedId;
    this.setState(newState, () => {
      this.props.onChange({...this.state});
    });
  }

  handleValueChange = (change, e) => {
    const newState = {};
    newState[change] = e.detail.value;
    this.setState(newState, () => {
      this.props.onChange({...this.state});
    });
  }

  render() {
    const selection = this.props.columns.filter(x => x[1] === this.props.data.column_name);
    return <ColumnLayout columns={3}>
      <div data-awsui-column-layout-root="true">
        <div>
          Column:
          <Select options={this.props.columns.map((x) => {
            return {label: x[0], id: x[1]};
          })}
                  selectedOption={{
                    label: selection.length > 0? selection[0][0]: "",
                    id: selection.length > 0? selection[0][0]: "",
                  }}
                  onChange={(e) => this.handleChange('column_name', e)}
                  selectedLabel="Selected"
                  filteringType={"auto"}
                  disabled={this.props.disabled}/>
        </div>
        <div>
          Operation:
          <Select options={FILTER_TYPES.map((x) => {
            return {label: x, id: x};
          })}
                  selectedOption={{
                    label: this.props.data.operation,
                    id: this.props.data.operation,
                  }}
                  onChange={(e) => this.handleChange('operation', e)}
                  selectedLabel="Selected"
                  disabled={this.props.disabled}/>
        </div>
        <div>
          Value:
          <Input value={this.props.data.arg}
                 onChange={(e) => this.handleValueChange('arg', e)}
                 disabled={this.props.disabled}/>
        </div>
      </div>
    </ColumnLayout>;
  }
}
